import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldDictionaryListService } from 'src/app/tabms/services/global/field-dictionary-list.service';
import { ActivatedRoute } from '@angular/router';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { RTL } from 'src/app/@theme/const';
import { Subject, takeUntil } from 'rxjs';
import { TabConst } from 'src/app/tabms/tab-consts';
import { FieldDicHelperService } from 'src/app/tabms/services/global/field-dic-helper.service';

@Component({
  selector: 'app-base-form-input',
  templateUrl: './base-form-input.component.html',
  styleUrl: './base-form-input.component.scss'
})
export class BaseFormInputComponent implements OnDestroy, OnInit {

  @Input() control: FormControl
  @Input() type: string = ''
   @Input() minVal: number = 0
 @Input({ required: true }) fieldName
  @Input() size: 'default' | 'compact' | 'xs' = TabConst.DefaultSize; // New input for size control
  @Input() validate: boolean = true //to apply validation only if form not criteria
  @Input() customClass
  @Input() readonly: boolean = false
  systemMenuId
  currentLang
  placeholder?: string
  defaultValue = null



  private destroy$: Subject<void> = new Subject<void>();

  get allClasses() {
    return {
      'mat-form-field-compact': this.size === 'compact',
      'mat-form-field-xs': this.size === 'xs',
      ...this.customClass
    }
  }

  constructor(
    private activateRoute: ActivatedRoute,
    private baseService: BaseService,
    private themeLayoutService: ThemeLayoutService,
    private fieldDicHelperService: FieldDicHelperService
  ) {
    this.activateRoute.params.pipe(takeUntil(this.destroy$)).subscribe({
      next: (params) => {
        this.systemMenuId = params['id']
      }
    })

    this.currentLang = this.baseService.getCurrentLanguage();

    this.themeLayoutService.directionChange.pipe(takeUntil(this.destroy$)).subscribe({
      next: (dir) => {
        this.currentLang = dir === RTL ? 'ar' : 'en'
        this.loadFieldData();
      }
    })

  }


  ngOnInit(): void {
    if (this.readonly) {
      this.control?.disable({ emitEvent: false });
    }

    this.loadFieldData();

    this.baseService.createFormDisplay
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          // console.log('subscribe createFormDisplay in input', res);

          if (res?.show && res?.id === null) {
            this.loadFieldData(); // create only
          }
        },
      });
  }

  private loadFieldData() {
    this.fieldDicHelperService
      .getFieldData(this.fieldName, this.systemMenuId, this.validate, this.control, this.currentLang)
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ placeholder, defaultValue, type, disabled }) => {
        this.placeholder = placeholder;
        if (type) this.type = type; // هيتغير لو autoincrement > 25
        if (defaultValue !== null && defaultValue !== undefined) {
            this.control.patchValue(defaultValue, { emitEvent: false, onlySelf: true });
        }
        // console.log('disabled', disabled);

        if (disabled) {
          this.control?.disable({ emitEvent: false });
        }
        if (this.type === 'number' && (this.control.value === '' || this.control.value == null)) {
          this.control.setValue(0, { emitEvent: false });
        }
      });
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
